import { render, staticRenderFns } from "./InternshipCapacitationsTopics.vue?vue&type=template&id=6696d126&"
import script from "./InternshipCapacitationsTopics.vue?vue&type=script&lang=js&"
export * from "./InternshipCapacitationsTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports